import _ from 'lodash'
import type {CssValue} from '../../constants'
import {deserializeUnit, serializeUnit} from '../utils/unit'
import type {
    AbsoluteLengthUnitArray,
    RelativeLengthUnitArray,
    AbsoluteLengthUnit,
    RelativeLengthUnit,
    CssLength
} from '@wix/document-services-types'

const ABSOLUTE_LENGTH_UNIT: AbsoluteLengthUnitArray = ['px', 'cm', 'mm', 'q', 'in', 'pt', 'pc']
const RELATIVE_LENGTH_UNIT: RelativeLengthUnitArray = ['em', 'ex', 'ch', 'rem', 'vw', 'vh', 'vmin', 'vmax']

const VALID_TYPES_SET = new Set<AbsoluteLengthUnit | RelativeLengthUnit>([
    ...ABSOLUTE_LENGTH_UNIT,
    ...RELATIVE_LENGTH_UNIT
])

const serialize = (val: any): CssValue | undefined => {
    if (!_.isPlainObject(val)) {
        return undefined
    }

    return serializeUnit({value: val.value, type: val.unit}, VALID_TYPES_SET)
}

const deserialize = (rule: CssValue): CssLength | undefined => {
    const unit = deserializeUnit(rule, VALID_TYPES_SET)
    if (!unit) {
        return undefined
    }
    return {value: unit.value, unit: unit.type}
}

export default {
    serialize,
    deserialize
}
